import Slider from "react-slick";
// import StaggeredListItem from "./StaggeredListItem";
import styles from './styles.module.css';
import { css } from "@emotion/react";
import HorizontalListItem from "./HorizontalListItem";
import { useEffect, useLayoutEffect, useRef, useState } from "react";

interface IHorizontalListProps {
    items: IHorizontalListItem[],
    onItemClick?: (item)=>void,
}

export interface IHorizontalListItem {
    image: string,
    aspectRatio?:number,
    extraData?: any,
}

export default function HorizontalList({items, onItemClick=(item)=>{}}:IHorizontalListProps) {
    const timerRef = useRef(null);
    const sliderRef = useRef<HTMLDivElement>();
    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const [showRightArrow, setShowRightArrow] = useState(false);

    const onClickGenerator = (item) => () => {
        onItemClick(item);
    }
    
    const calcArrows = () => {
        if(timerRef.current)clearTimeout(timerRef.current);
        timerRef.current = setTimeout(()=>{
        const sliderWidth = sliderRef.current?.scrollWidth;
        const slidesWidth = sliderRef.current?.clientWidth;
        const scrollXOffset = sliderRef.current?.scrollLeft;
        setShowRightArrow(sliderWidth > scrollXOffset + slidesWidth + 10);
        setShowLeftArrow(!!scrollXOffset);
        },300);
    }

    useEffect(()=>{
        if(!sliderRef.current) return;
        const observer = new ResizeObserver(calcArrows);
        sliderRef.current.addEventListener("scroll",calcArrows);
        observer.observe(sliderRef.current);
        return () => {
            sliderRef.current?.removeEventListener("scroll",calcArrows);
            observer.disconnect();
        }
    },[items?.length]);


    return <div css={emotionStyles.container}>
             {showLeftArrow && <div css={css`
            box-shadow: 0px 0px 16px 0px #0000003D;
            width: 40px;
            height: 40px;
            padding: 8px, 8px, 8px, 8px;
            border-radius: 1000px;
            background-color:white;
        `} onClick={()=>{
                sliderRef.current.scrollBy({
                    left: -600,
                    behavior: 'smooth'
                })
            }} style={{left:0, position:'absolute', top:'50%', transform:"translate(-50%, -50%) rotate(-180deg)", zIndex:6, cursor:"pointer", display:'flex', justifyContent:'center', alignItems:"center"}}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M8 4L16 12L8 20" stroke="#262626" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>}
            <div ref={sliderRef} css={css`
                ::-webkit-scrollbar: {
                    display: 'none' !important;
                }   
            `}  style={{width:'100%',overflowX:'scroll', display:'flex', gap:16, alignItems:'flex-end', flexWrap:'nowrap', padding:'20px 10px' }}> 
                {items?.map((item)=><HorizontalListItem image={item.image} onClick={onClickGenerator(item)}/>)}
            </div>
            {showRightArrow && <div css={css`
            box-shadow: 0px 0px 16px 0px #0000003D;
            width: 40px;
            height: 40px;
            padding: 8px, 8px, 8px, 8px;
            border-radius: 1000px;
            background-color:white;
        `} onClick={()=>{
                sliderRef.current.scrollBy({
                    left: 600,
                    behavior: 'smooth'
                })
            }} style={{right:0, position:'absolute', top:'50%', transform:"translate(25%, -50%)", zIndex:1, cursor:'pointer', display:'flex', justifyContent:'center', alignItems:"center"}}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M8 4L16 12L8 20" stroke="#262626" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>}
    </div>
}

const emotionStyles = {
    container: css`
        position:relative;
        & .slick-track {
            display: inline-flex;
            align-items: flex-end;
            gap: 16px;
        }
    `
}